// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__8+Yi1","modalBody":"StaffClientsModal_modalBody__I6z7y","formControl":"StaffClientsModal_formControl__q4UI4"};